module.exports = __webpack_public_path__ + "img/phone-call-02.0db89a8b.svg";